<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', cst)">
      <v-card v-if="cst" :loading="salvando">
        <v-card-title> {{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} CST </v-card-title>

        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="cst.descricao"
                    label="Descrição"
                    required
                    :rules="[obrigatorio]"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field
                    v-model="cst.codigo"
                    label="Codigo"
                    required
                    :rules="[obrigatorio]"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="red darken-1" type="button" text @click="dialog = false"> Cancelar </v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(cst)"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import CST from '@/models/cst'
import CSTService from '@/services/cst/cst'
import { obrigatorio } from '@/shareds/regrasForm'

export default {
  props: ['showDialog', 'cstParam', 'operacao', 'itens'],
  data: () => ({
    dialog: false,
    cst: new CST(),
    obrigatorio: obrigatorio,
    salvando: false,
    validForm: false,
    dataError: ''
  }),

  watch: {
    showDialog() {
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    cstParam() {
      return this.cstParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },

  methods: {
    initialize() {
      this.cst = new CST()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()

      this.cst = this.cstParam
    },

    async salvar(item) {
      this.salvando = true
      try {
        const data = {
          ...item
        }

        const cstSalva =
          this.operacao === 'adicionar'
            ? await CSTService.create({ ...data })
            : await CSTService.update(data.id, data)

        this.$emit('confirmado', cstSalva)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.dataError = ''
      this.showMessageError = false
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
